import { USER_INFO } from "../config/constants";
import { isEmptyOrNull } from "./DataUtils";

interface CurrentUser {
    token: string;
}

const getCurrentUser = (): CurrentUser | null => {
    const userString = localStorage.getItem(USER_INFO);
    if (!isEmptyOrNull(userString)) {
        try {
            const user = JSON.parse(userString as string);
            if (user && typeof user.token === 'string') {
                return user as CurrentUser;
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error("Failed to parse user info from localStorage:", error);
        }
    }
    return null;
};

export const isLoginRequired = (): boolean => {
    const currentUser = getCurrentUser();
    return !currentUser?.token;
};
